import { h, Component } from 'preact';
import { getCurrencyMatrix } from '@os/cloudquote';
import { generatePriceFormatter } from '../../lib/util';
import { FinanceSpinner } from '../glyphs';
import Flag from '../flags';
import style from './style';
import Container from '../container';
import { Text } from 'preact-i18n';


const formatExchangeRate = generatePriceFormatter({ SecurityTypeCode: 'CURRENCY' });
const INTL_NS = 'currencies';
const colNames = ['Dollar','Euro','Canadian','Peso'];

export default class CurrencyMatrix extends Component {

	componentWillMount() {
		getCurrencyMatrix(['USD','EUR','CAD','MXN'])
			.then((data) => this.setState({ data }));
	}

	render({ transform = 'uppercase' }, { data }) {
		if (!data) {
			return (
				<div class={style['currency-matrix']}>
					<FinanceSpinner />
				</div>
			);
		}
		return (

			<Container transform={transform} title={<Text id={`${INTL_NS}.currency`} />}>
				<div class={style['currency-matrix']}>
					<table>
						<thead>
							<tr>
								<th />
								<th><Flag country="usa" /></th>
								<th><Flag country="europe" /></th>
								<th><Flag country="canada" /></th>
								<th><Flag country="mexico" /></th>
							</tr>
							<tr>
								<th />
								{ data.columns.map( (col,i) => (<th>{col}<small><Text id={`${INTL_NS}.currencyLong.${colNames[i]}`} /></small></th>))}
							</tr>
						</thead>
						<tbody>
							{ data.rows.map( (row,i) => (
								<tr>
									<th>1 { data.columns[i] }</th>
									{ row.map( (price,j) => <td class={style.price}>{ formatExchangeRate(price) }</td>) }
								</tr>
							))}
						</tbody>
					</table>
				</div>
			</Container>
		);
	}
}
